import { Vector2, Color, Texture } from 'three';

import { TextureType } from './enums';

/**
 * Priority levels for texture loading.
 * Lower numbers = higher priority (loaded first).
 */
export enum TextureLoadPriority {
	/** Critical textures (selected floor + sky) - blocks scene render */
	CRITICAL = 0,
	/** Scene-specific textures (countertop, surround) - needed for geometry */
	SCENE = 1,
	/** Background preloading (other options for instant switching) */
	PRELOAD = 2
}

export interface TextureInfo {
	key: string;
	texture: string;
	handleAsHdr: boolean;
	alphaMapPath: string;
	normalMapPath: string;
	normalScale: Vector2;
	displacementMapPath: string;
	displacementScale: number;
	displacementBias: number;
	scale: number | null;
	metalness: number;
	roughness: number;
	brightness: number | null; // emissive
	transparent: boolean;
	envMapIntensity: number;
	color: Color | null;
	textureType: TextureType;
	/** Optional clearcoat intensity for metallic surfaces (0-1, recommended 0.1-0.2) */
	clearcoat?: number;
	/** Optional clearcoat roughness (0-1, recommended 0.25) */
	clearcoatRoughness?: number;
	/** Optional loading priority for progressive texture loading */
	loadPriority?: TextureLoadPriority;
	/** Optional KTX2 compressed texture path (used instead of texture when KTX2 is enabled) */
	ktx2Path?: string;
	/** Optional base color for plain/untextured faces (hex number, e.g. 0x808080) */
	baseColor?: number;
}

